import { Link } from "react-router";
import { Logo } from "./logo";
import { urlHome } from "../urls";
import { ArrowLeft } from "lucide-react";

interface HeaderProps {
  backLink?: string;
}

export function Header({ backLink }: HeaderProps) {
  return (
    <div className="flex items-center justify-between border-b p-4 w-full relative min-h-16">
      {backLink && (
        <Link
          to={backLink}
          viewTransition
          className="flex items-center gap-2 text-md font-medium text-gray-500"
        >
          <ArrowLeft className="size-6" />
          Volver
        </Link>
      )}
      <Link
        to={urlHome()}
        viewTransition
        className="absolute left-1/2 -translate-x-1/2"
      >
        <Logo />
      </Link>
      <div />
    </div>
  );
}
